
<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="500"
    style="z-index: 6"
  >
    <v-form ref="addCategoryForm" @submit.prevent="submit">
      <v-card class="glass-card">
        <!-- Header -->
        <v-card-title class="glass-header pa-4">
          <v-icon color="white" size="28" class="mr-2">mdi-percent</v-icon>
          <span class="header-text">Popust</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <v-container>
            <!-- Odabir popusta -->
            <v-row class="justify-center">
              <v-col cols="12">
                <v-select
                  outlined
                  label="Odaberi popust"
                  v-model="selectedDiscount"
                  item-text="name"
                  return-object
                  :items="filteredDiscounts"
                  :rules="[rules.req]"
                  class="filter-select"
                  hide-details="auto"
                >
                </v-select>
              </v-col>
            </v-row>

            <!-- Ručni unos iznosa -->
            <v-row
              class="justify-center mt-4"
              v-if="
                selectedDiscount !== undefined &&
                selectedDiscount.type === 'MANUAL'
              "
            >
              <v-col cols="12">
                <v-card outlined class="manual-amount-card" elevation="0">
                  <v-card-text class="pb-2">
                    <v-row align="center" class="ma-0">
                      <v-col cols="7" class="pa-2">
                        <quantity-input
                          dense
                          outlined
                          label="Iznos"
                          v-model="amt"
                          :rules="[rules.req]"
                          hide-details="auto"
                          class="amount-input"
                        ></quantity-input>
                      </v-col>
                      <v-col cols="5" class="pa-2 d-flex justify-center">
                        <v-switch
                          v-model="switchType"
                          inset
                          :label="switchType ? 'EUR' : '%'"
                          :disabled="isCartDiscount"
                          class="currency-switch mt-0"
                          hide-details
                          color="primary"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Footer -->
        <v-divider class="footer-divider"></v-divider>
        <v-card-actions class="pa-4 footer-actions d-flex justify-center">
          <v-btn
            class="add-discount-btn"
            elevation="0"
            large
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            <v-icon left small>mdi-check</v-icon>
            Dodaj popust
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>

import { df } from '@/plugins/firebase'
import rules from '@/plugins/rules'
import state from '@/state'
import QuantityInput from '../../../../components/QuantityInput.vue'
export default {
  components: { QuantityInput },
  name: 'AddCategory',
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  data: () => ({
    visible: false,
    name: undefined,
    submitting: false,
    selectedDiscount: undefined,
    manualType: undefined,
    discounts: [],
    amt: undefined,
    amtValid: false,
    currency: undefined,
    itemID: undefined,
    basketDiscount: false,
    rules: {
      req: rules.req('Required field')
    },
    multiplier: 0,
    listeners: [],
    switchType: false
  }),
  computed: {
    selectedType () {
      if (this.switchType === false) {
        return 0
      } else {
        return 1
      }
    },
    discTypes () {
      return [
        { name: '%', value: 'RATE' },
        { name: this.currency, value: 'AMOUNT' }
      ]
    },
    // Filter discounts to only show RATE types for cart-wide discounts
    filteredDiscounts () {
      if (this.itemID === 'ALL_ITEMS') {
        // Only RATE (percentage) discounts for entire cart
        return this.discounts.filter(d => d.type === 'RATE' || d.type === 'MANUAL')
      }
      return this.discounts
    },
    // Check if this is a cart-wide discount
    isCartDiscount () {
      return this.itemID === 'ALL_ITEMS'
    }

  },
  mounted () {
    this.currency = 'HRK'
    if (Date.now() / 1000 > 1672527599) {
      this.currency = 'EUR'
    }

    this.getMultiplier()
    const query = df.collection(`companies/${state.getCurrentCompany().id}/discounts`).orderBy('name', 'asc')
    query.get().then((snapshot) => {
      snapshot.forEach((doc) => {
        const discount = doc.data()
        if (discount !== undefined && discount.users !== undefined && discount.users !== null && discount.users.length > 0 && discount.active === true) {
          discount.users.forEach(id => {
            if (id === state.getUser()?.id) {
              discount.name = this.capitalizeFirst(discount.name)
              this.discounts.push(discount)
            }
          })
        } else {
          if (discount.active === true) {
            discount.name = this.capitalizeFirst(discount.name)
            this.discounts.push(discount)
          }
        }
      })
    })

    this.discounts.sort((a, b) => a.name.localeCompare(b.name))
  },
  methods: {
    amountValid () {
      if (this.selectedType !== undefined) {
        switch (this.selectedType) {
          case 0: {
            if (this.amt >= 100 || this.amt <= 0) {
              this.submitting = false
              this.amtValid = false
            } else {
              this.submitting = true
              this.amtValid = true
            }
            break
          }
          case 1: {
            if (this.amt > 1) {
              this.submitting = true
              this.amtValid = true
            }
            break
          }
        }
      }
    },
    capitalizeFirst (name) {
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    open (basketDiscount = false, itemID, currency) {
      this.currency = currency
      this.visible = true

      this.basketDiscount = basketDiscount
      if (itemID !== '') {
        this.itemID = itemID
      }

      // Force percentage mode for cart-wide discounts
      if (itemID === 'ALL_ITEMS') {
        this.switchType = false // false = percentage mode
      }
    },
    close () {
      this.$emit('close')
      this.visible = false
      this.selectedDiscount = undefined
      this.basketDiscount = false
      this.manualType = undefined
      this.submitting = false
      this.amtValid = false
      this.itemID = undefined
      this.switchType = false
    },
    createImage (file) {
      const reader = new FileReader()

      reader.onload = e => {
        this.picture = e.target.result
      }
      reader.readAsDataURL(file)
    },
    submit () {
      if (this.selectedDiscount === undefined) return false

      // this.amountValid()
      // if (!this.amtValid) return false
      let discount = this.selectedDiscount
      if (this.selectedDiscount.type === 'MANUAL') {
        if (!this.amt) {
          return
        }
        this.submitting = true

        this.amt = parseFloat(this.amt.toString().replace(',', '.'))

        var rate = 0
        var amt = this.amt
        if (this.selectedType === 0) {
          rate = this.amt * 100
        } else {
          amt = this.amt * 100
        }

        discount = {
          name: this.selectedDiscount.name,
          active: true,
          amount: amt,
          rate: rate && rate > 0 ? rate : null,
          company_id: state.getCurrentCompany().id,
          id: this.selectedDiscount.id,
          type: this.selectedType === 0 ? 'RATE' : 'AMOUNT'
        }
      }

      if (this.selectedDiscount.users && this.selectedDiscount.users.length > 0) {
        discount.users = this.selectedDiscount.users
      }

      discount.basketDiscount = this.basketDiscount
      if (this.itemID !== undefined) {
        discount.itemID = this.itemID
      }

      this.$emit('add', { ...discount })
      this.submitting = false
      this.close()
    },
    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    }
  }
}
</script>

<style scoped>
/* Glass Card Style */
.glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  box-shadow: 0 8px 32px rgba(57, 137, 201, 0.15) !important;
  overflow: hidden;
}

/* Header with Brand Gradient */
.glass-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  position: relative;
  border-bottom: 1px solid rgba(57, 137, 201, 0.3);
}

.glass-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  z-index: 0;
}

.header-text {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: white !important;
  letter-spacing: 0.3px !important;
  position: relative;
  z-index: 1;
}

.close-btn {
  position: relative;
  z-index: 1;
  transition: all 0.2s ease !important;
}

.close-btn:hover {
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Filter Select Dropdown */
.filter-select >>> .v-input__control {
  min-height: 52px !important;
}

.filter-select >>> .v-select__selection {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
}

.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.3) !important;
  border-radius: 12px !important;
  border-width: 2px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.5) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

/* Manual Amount Card */
.manual-amount-card {
  border: 2px solid rgba(57, 137, 201, 0.2) !important;
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.5) !important;
  transition: all 0.2s ease !important;
}

.manual-amount-card:hover {
  border-color: rgba(57, 137, 201, 0.35) !important;
  background: rgba(255, 255, 255, 0.7) !important;
}

/* Amount Input */
.amount-input >>> .v-input__control {
  min-height: 52px !important;
}

.amount-input >>> input {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
}

.amount-input.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.3) !important;
  border-radius: 10px !important;
}

.amount-input.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.5) !important;
}

.amount-input.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
}

/* Currency Switch */
.currency-switch {
  transform: scale(1.1);
}

.currency-switch >>> .v-input--switch__track {
  background: rgba(57, 137, 201, 0.3) !important;
  border-radius: 12px !important;
  height: 28px !important;
}

.currency-switch >>> .v-input--switch__thumb {
  width: 24px !important;
  height: 24px !important;
  background: white !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
}

.currency-switch >>> .v-input--selection-controls__input {
  width: 56px !important;
  height: 32px !important;
}

.currency-switch >>> .v-label {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  margin-left: 12px !important;
}

/* Footer */
.footer-divider {
  border-color: rgba(57, 137, 201, 0.2) !important;
}

.footer-actions {
  background: rgba(57, 137, 201, 0.02) !important;
}

/* Add Discount Button */
.add-discount-btn {
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 32px !important;
  height: 48px !important;
  min-width: 160px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.add-discount-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  border-color: #3989C9 !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  transform: translateY(-1px);
}

.add-discount-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* Touchscreen optimizations */
.v-btn {
  min-height: 44px !important;
}

.v-btn.v-size--large {
  min-height: 52px !important;
}
</style>
